import React, { ReactElement } from "react";
import { DateTime } from "luxon";
import * as _ from "lodash";
import { List, ListItem } from "@mui/material";
import { BackButton } from "../../../views/common-forms/components";
import { DeviationMessage } from "./DeviationStampMessages";
import { DeviationListProps, StampDirection } from "../../../shared/timeclock/models";

export function DeviationList(props: DeviationListProps): ReactElement {
    const {
        onClickHandler,
        onBackClick,
        deviations,
        direction,
        ...deviationMsgProps } = props;
    
    const deviationChunks = _.chunk(
        deviations.filter(d => d.direction === StampDirection[direction]),
        3
    );
    const currentTime = DateTime.now();
    
    
    return (
        <div className="stamp-list">
            <div className="stamp-messagebox">
                <DeviationMessage
                    direction={direction}
                    {...deviationMsgProps}
                    currentTime={currentTime}
                />
            </div>
            {deviationChunks.map((d, index) =>
                <div className="column" key={index}>
                    <List>
                        {d.map((stampOp) =>
                            <ListItem
                                className="tc-list-entry"
                                key={stampOp.direction + "_" + stampOp.deviationCodeRef}
                                onClick={() => onClickHandler(stampOp)}
                            >
                                {stampOp.description}
                            </ListItem>
                        )}
                    </List>
                </div>
            )}
            <BackButton onClick={onBackClick} />
        </div>
    );
}
